module.exports = __webpack_public_path__ + "static/img/logo.6823659.png";


//////////////////
// WEBPACK FOOTER
// ./static/logo.png
// module id = 7Ogj
// module chunks = 61